import { Box } from '@mui/material'
import Icon from '@mui/icons-material/Stars'

import { useRecordContext } from 'react-admin'

const StarRatingField = ({ size = 'large' }, ...props) => {
  const record = props.record || useRecordContext()
  if (!record) return null

  if (record.rating > 5) record.rating = 5

  return (
    <Box
      component="span"
      display="flex"
      sx={{
        opacity: 0.87,
        whiteSpace: 'nowrap',
      }}
    >
      {Array(record.rating)
        .fill(true)
        .map((_, i) => (
          <Icon
            key={i}
            sx={{
              width: size === 'large' ? 20 : 15,
              height: size === 'large' ? 20 : 15,
            }}
          />
        ))}
    </Box>
  )
}

StarRatingField.defaultProps = {
  label: 'resources.reviews.fields.rating',
  source: 'rating',
}

export default StarRatingField
